import { Component, ViewEncapsulation, inject } from '@angular/core';
import { ToastService, ToastItem } from '@core/services/toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './toast-container.component.scss',
  template: `
    <div class="toast-container">
      @for (item of toast.toasts(); track item.id) {
        <div
          class="toast-item toast-{{ item.severity }}"
          [class.toast-exit]="item.exiting"
        >
          <div class="toast-icon-box toast-icon-box--{{ item.severity }}">
            <i class="pi" [class]="iconClass(item.severity)"></i>
          </div>

          <div class="toast-content">
            <span class="toast-summary">{{ item.summary }}</span>
            <span class="toast-detail">{{ item.detail }}</span>
          </div>

          @if (item.actionLabel && item.actionFn) {
            <button class="toast-action" (click)="item.actionFn!()">
              {{ item.actionLabel }}
            </button>
          }

          @if (item.closable) {
            <button class="toast-close" (click)="toast.dismiss(item.id)">
              <i class="pi pi-times"></i>
            </button>
          }

          <div
            class="toast-progress toast-progress--{{ item.severity }}"
            [style.animation-duration.ms]="item.life"
          ></div>
        </div>
      }
    </div>
  `,
})
export class ToastContainerComponent {
  readonly toast = inject(ToastService);

  iconClass(severity: string): string {
    switch (severity) {
      case 'success': return 'pi-check-circle';
      case 'error':   return 'pi-times-circle';
      case 'warning': return 'pi-exclamation-triangle';
      case 'info':    return 'pi-info-circle';
      default:        return 'pi-info-circle';
    }
  }
}
